<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import Banner from 'dashboard/components-next/banner/Banner.vue';

const { t } = useI18n();
const router = useRouter();

const whatsappInboxes = useMapGetter('inboxes/getWhatsAppInboxes');
const hasWhatsappInbox = computed(() => whatsappInboxes.value.length > 0);

const goToWhatsappSetup = () => {
  router.push({ name: 'settings_inbox_new' });
};
</script>

<template>
  <div class="flex flex-col gap-4 mb-4">
    <Banner
      :color="hasWhatsappInbox ? 'teal' : 'amber'"
      :action-label="
        hasWhatsappInbox ? null : t('INTEGRATION_APPS.BITRIX.WHATSAPP_LINK.CTA')
      "
      @action="goToWhatsappSetup"
    >
      <span v-if="hasWhatsappInbox">
        {{
          t('INTEGRATION_APPS.BITRIX.WHATSAPP_LINK.CONNECTED', {
            inboxName: whatsappInboxes[0].name,
          })
        }}
      </span>
      <span v-else>
        {{ t('INTEGRATION_APPS.BITRIX.WHATSAPP_LINK.MISSING') }}
      </span>
    </Banner>
  </div>
</template>
